import { useState, useEffect, useContext } from 'react';
import {
    Grid,
    Box,
    Paper,
    Table,
    TableRow,
    TableCell,
    TableContainer,
    TableHead,
    TableBody,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
    AppContext,
    SttFullDialog,
    SttFormTextarea,
} from '../../../sporttia/all';

export default function ApiModelDialog({ idModel, onClose }: any) {
    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();
    const [model, setModel] = useState<any>();

    /**
     * Load model
     */
    const loadModel = () => {
        cxt.api('GET', `/apis/models/${idModel}`, {
            success: (r: any) => {
                setModel(r.apiModel);
            },
        });
    };

    /**
     * Id model changes
     */
    useEffect(() => {
        if (idModel) loadModel();
    }, [idModel]);

    // -----| Render |-----
    return (
        <SttFullDialog
            title={t('api.model')}
            open={idModel !== null}
            onClose={onClose}
            buttons={[
                {
                    type: 'custom',
                    caption: t('buttons.close'),
                    onClick: onClose,
                },
            ]}
        >
            <Box mt={4}>
                {model && (
                    <Grid container spacing={3}>
                        <Grid size={{ md: 6 }}>
                            <Grid container>
                                <SttFormTextarea
                                    grid
                                    md={12}
                                    disabled
                                    rows={50}
                                    caption="JSON"
                                    defVal={model.example}
                                />
                            </Grid>
                        </Grid>

                        <Grid size={{ md: 6 }}>
                            <Paper>
                                <Box p={3}>
                                    <TableContainer>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>
                                                        {t('labels.name')}
                                                    </TableCell>
                                                    <TableCell>
                                                        {t(
                                                            'general.description',
                                                        )}
                                                    </TableCell>
                                                    <TableCell>
                                                        {t('general.type')}
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {model.properties &&
                                                    model.properties.rows.map(
                                                        (prop: any) => (
                                                            <TableRow
                                                                key={prop.id}
                                                            >
                                                                <TableCell align="center">
                                                                    <b>
                                                                        {
                                                                            prop.name
                                                                        }
                                                                    </b>
                                                                </TableCell>
                                                                <TableCell align="left">
                                                                    {
                                                                        prop.description
                                                                    }
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {prop.type}
                                                                </TableCell>
                                                            </TableRow>
                                                        ),
                                                    )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>
                )}
            </Box>
        </SttFullDialog>
    );
}
